import { ConfigurationSaisieDonneesAnalyse } from "./configurationSaisieDonneesAnalyse";
import { Probleme } from "./probleme";

export class Graphique {
  graphiqueId: number;
  parametre: string;
  utilisateurId: string;
  type: string;
  labels: string;
  siteId: number;
  nom: string;
  configurationSaisieDonneesAnalyses: ConfigurationSaisieDonneesAnalyse[];
  problemes: Probleme[];
}
